import {ShareLandMarketContract} from '#/contracts/ShareLandMarketContract';
import environment from '#/environment/environment';
import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {Nullable} from '#/types/helpers';
import {useQuery} from '@tanstack/react-query';
import {Hex} from 'viem';

export const useLimitOrdersIds = (
  account: Nullable<Hex>,
  sharelandMarketContract: Nullable<ShareLandMarketContract>,
) => {
  return useQuery({
    queryKey: [baseKeysUseQuery.useLimitOrdersIds, sharelandMarketContract?.land.id],
    queryFn: () =>
      environment.isWaitlistNet ? ([] as readonly bigint[]) : sharelandMarketContract!.ordersByAccount(account!),
    enabled: !!sharelandMarketContract && !!account,
  });
};
